import type { DashboardContext } from "@/pages/project/dashboard-kinds";
import { ListingReference } from "./ListingReference";
import { useListing } from "./use-listing";

// Die Angabe im Kopf des Dashboards einer Ausschreibung, neben "Angelegt am": die Kennziffer. Sie
// steht im Kopf und nicht nur in der Übersicht, weil man sie auf jeder Fläche braucht, etwa in den
// Bewerbungen, wenn man einer Person schreibt. Anders als "Angelegt am" lesen sie auch Empfänger.
export function ListingHeaderMeta({ ctx }: { ctx: DashboardContext }) {
  // Dieselbe Abfrage wie die Quelle des Dashboards, also aus dem Cache.
  const { listing } = useListing(ctx.entity.id);
  return listing ? <ListingReference reference={listing.reference} /> : null;
}
